var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.205 36.203h1.984V16.217h-1.984zM23.008 36.203h1.984V16.217h-1.984zM16.811 36.203h1.984V16.217h-1.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.09 40.258H11.91l-.879-28.096h25.938l-.879 28.096zM18.795 10.177h10.409V7.742H18.795v2.435zm23.858 0H31.189v-4.42H16.811v4.42H5.347v1.985h3.7l.939 30.08h28.028l.939-30.08h3.7v-1.985z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.33ca835ec8f5048c0e937275e362d689.svg";
export { ForwardRef as ReactComponent };